import type { AddButton, RicosServices } from 'ricos-types';
import { Node_Type } from 'ricos-types';
import {
  decorateComponentWithProps,
  INSERT_PLUGIN_BUTTONS,
  TOOLBARS,
} from 'wix-rich-content-editor-common';

import { InsertPluginIcon } from './assets/icons';
import { InsertModal } from './components/insert-modal';
import { INSERT_POLL_MODAL_ID } from './consts';
import type { PollPluginEditorConfig } from './types';

export const toolbarsToAddIn: (TOOLBARS.MOBILE | TOOLBARS.FOOTER | TOOLBARS.SIDE)[] = [
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
  TOOLBARS.MOBILE,
];

export const getAddButtons = (
  config: PollPluginEditorConfig,
  _services: RicosServices
): AddButton[] => {
  return [
    {
      id: Node_Type.POLL,
      label: INSERT_PLUGIN_BUTTONS.POLLS,
      dataHook: INSERT_PLUGIN_BUTTONS.POLLS,
      icon: InsertPluginIcon,
      tooltip: 'Poll_InsertPoll_Tooltip',
      toolbars: [TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE],
      command: () => true,
      modal: {
        id: INSERT_POLL_MODAL_ID,
        Component: decorateComponentWithProps(InsertModal, {
          config,
        }),
        noPadding: true,
      },
      menuConfig: {
        tags: 'Poll_plugin_search_tags',
      },
    },
  ];
};
